import api from './axiosConfig';

export const chatClient = async (text, sessionId, endSession) => {
  let requestData = {
    text,
    sessionId,
    endSession,
  };

  try {
    const response = await api({
      method: 'post',
      url: process.env.REACT_APP_CHAT_URL,
      headers: {
        'Content-Type': 'application/json',
      },
      data: requestData,
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
};
